import { render, staticRenderFns } from "./ImportConfigurations.vue?vue&type=template&id=09548f6e"
import script from "./ImportConfigurations.vue?vue&type=script&lang=js"
export * from "./ImportConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports